// src/pages/admin/tabs/QuotasUsage.jsx
export default function QuotasUsage() {
    return <div>Quotas &amp; Usage</div>;
  }
  